import * as yup from 'yup';

export const userProfileSchema = yup.object({
  emailAddress: yup
    .string()
    .email('Invalid format. Please enter valid email.')
    .matches(
      /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Please enter valid email. Only letters (a-z), numbers (0-9), period (.), underscore (_), plus (+), and hyphen (-) are allowed.',
    )
    .required('Please enter Email'),
  firstName: yup
    .string()
    .matches(/^[\p{L}\p{N}\p{Z}\p{M}.'’-]*$/u, 'Please enter valid first name')
    .required('Please enter First Name')
    .test('is-not-empty-or-space', 'Please enter valid first name', (value) => {
      return value?.trim().length > 0;
    }),
  lastName: yup
    .string()
    .matches(/^[\p{L}\p{N}\p{Z}\p{M}.'’-]*$/u, 'Please enter valid last name')
    .required('Please enter Last Name')
    .test('is-not-empty-or-space', 'Please enter valid last name', (value) => {
      return value?.trim().length > 0;
    }),
  middleName: yup
    .string()
    .matches(/^[\p{L}\p{N}\p{Z}\p{M}.'’-]*$/u, 'Please enter valid middle name'),
});
